import { Box, transition } from "@chakra-ui/react";
import Xarrow, { useXarrow, Xwrapper } from "react-xarrows";
import usePipelineStore from "../../stores/pipeline-store";
import useRuntimeStore from "../../stores/runtime-store";

const StepArrows: React.FC = ({}) => {
    const { pipeline } = usePipelineStore((state: any) => state);
    const { arrowsRefs } = useRuntimeStore((state: any) => state);
    if (!pipeline || !arrowsRefs) return null;

    return (
        <>
            {pipeline.editorSettings.stepIds.map((stepId: string) => {
                let arrows: any = [];
                if (
                    (pipeline as PipelineJson).steps[stepId] &&
                    arrowsRefs[stepId]
                ) {
                    const stepTransitions = (pipeline as PipelineJson).steps[
                        stepId
                    ].transitions;

                    for (var i = 0; i < stepTransitions.length; i++) {
                        const transition = stepTransitions[i];
                        if (!transition.targetStepId) return;
                        const targetId = transition.targetStepId;

                        let start = `${stepId}_center`;
                        let end = `${targetId}_center`;
                        let shortestD = -1;
                        ["left", "right", "up", "down"].forEach((fromPoint) => {
                            ["left", "right", "up", "down"].forEach(
                                (toPoint) => {
                                    const ao = document.getElementById(
                                        `${stepId}_${fromPoint}`
                                    );
                                    const bo = document.getElementById(
                                        `${targetId}_${toPoint}`
                                    );

                                    if (!ao || !bo) {
                                        return;
                                    }

                                    const a = ao.getBoundingClientRect();
                                    const b = bo.getBoundingClientRect();
                                    const d = Math.sqrt(
                                        Math.pow(a.x - b.x, 2) +
                                            Math.pow(a.y - b.y, 2)
                                    );

                                    if (shortestD == -1 || d < shortestD) {
                                        shortestD = d;
                                        start = `${stepId}_${fromPoint}`;
                                        end = `${targetId}_${toPoint}`;
                                    }
                                }
                            );
                        });
                        // console.log({ start, end });
                        const arrow = (
                            <Xarrow
                                key={`${stepId}, ${transition.targetStepId}`}
                                color={transition.color}
                                labels={
                                    <div
                                        style={{
                                            backgroundColor: "#edf2f6",
                                            color: transition.color,
                                            fontSize: "0.8em",
                                            fontStyle: "bold",
                                        }}
                                    >
                                        {transition.label}
                                    </div>
                                }
                                path="straight"
                                strokeWidth={2}
                                dashness={false}
                                // showHead={true}
                                start={start}
                                end={end}
                                zIndex={-1}
                            />
                        );
                        // console.log(arrow);
                        arrows.push(arrow);
                    }
                }

                return arrows;
            })}
        </>
    );
};

export default StepArrows;
